import { render } from "./SettingsPage.vue?vue&type=template&id=0e5ea8d1&scoped=true"
import script from "./SettingsPage.vue?vue&type=script&lang=js"
export * from "./SettingsPage.vue?vue&type=script&lang=js"

import "./SettingsPage.vue?vue&type=style&index=0&id=0e5ea8d1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0e5ea8d1"

export default script